var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newQuickAddTreeNode(data) {
    var instance = {
        __type: "QuickAddTreeNode:#DecisionsFramework.Design.Flow",
        NodeId: null,
        NodePath: null,
        Label: null,
        Information: null,
        NodeType: 0 /* QuickAddTreeNodeType.Toolbox */,
        CanCreate: false,
        CreationInfo: null,
        CanBeFavorite: false,
        FavoriteType: 3 /* FavoriteType.None */,
        ExpandWhenLoaded: false,
        ItemType: 0 /* FlowStepToolboxItemType.Step */,
        Image: null
    };
    return __assign(__assign({}, instance), data);
}
export function isQuickAddTreeNode(object) {
    return object.__type === "QuickAddTreeNode:#DecisionsFramework.Design.Flow";
}
